export default __webpack_public_path__ + "static/media/products-grid-vertical-theme1.9c762c7d.svg";